import { REQUEST, SUCCESS, FAILURE } from '@/plugins/store'

export default {
  CREATE_CONTRACT_REQUEST(state) {
    REQUEST(state)
  },
  CREATE_CONTRACT_SUCCESS(state, data) {
    SUCCESS(state)
    state.contract = data
  },
  CREATE_CONTRACT_FAILURE(state, error) {
    FAILURE(state, error)
  },
  GET_PROVINCES_REQUEST(state) {
    REQUEST(state)
  },
  GET_PROVINCES_SUCCESS(state, provinces) {
    SUCCESS(state)
    state.provinces = provinces
  },
  GET_PROVINCES_FAILURE(state, error) {
    FAILURE(state, error)
  },
  GET_WARDS_REQUEST(state) {
    REQUEST(state)
  },
  GET_WARDS_SUCCESS(state, wards) {
    SUCCESS(state)
    state.wards = wards
  },
  GET_WARDS_FAILURE(state, error) {
    FAILURE(state, error)
  },
  GET_CONTRACT_REQUEST(state) {
    REQUEST(state)
  },
  GET_CONTRACT_SUCCESS(state, data) {
    SUCCESS(state)
    state.contract = data
  },
  GET_CONTRACT_FAILURE(state, error) {
    FAILURE(state, error)
  },
  UPDATE_CONTRACT_REQUEST(state) {
    REQUEST(state)
  },
  UPDATE_CONTRACT_SUCCESS(state, data) {
    SUCCESS(state)
    state.contract = data
  },
  UPDATE_CONTRACT_FAILURE(state, error) {
    FAILURE(state, error)
  },
}
